/**
 * Browser privacy signals.
 *
 * Vercel Web Analytics and Speed Insights do not read Do Not Track or Global
 * Privacy Control themselves: their served script only filters bots. The
 * opt-out has to happen on our side, by dropping events in `beforeSend`.
 */

type SignalNavigator = {
  doNotTrack?: string | null;
  globalPrivacyControl?: boolean;
};

type SignalWindow = {
  doNotTrack?: string | null;
  navigator?: SignalNavigator;
};

/**
 * True when the visitor has asked not to be tracked, through Do Not Track
 * (`navigator.doNotTrack`, or `window.doNotTrack` on older browsers) or
 * Global Privacy Control (`navigator.globalPrivacyControl`).
 */
export function hasPrivacyOptOutSignal(
  win: SignalWindow | undefined = typeof window === 'undefined'
    ? undefined
    : (window as unknown as SignalWindow)
): boolean {
  if (!win) return false;
  const nav = win.navigator;
  return nav?.doNotTrack === '1' || win.doNotTrack === '1' || nav?.globalPrivacyControl === true;
}
